import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.MENU_DUPLICATE_SUCCESS, menu: data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.MENU_DUPLICATE_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const menuDuplicate = (menuId, data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.MENU_DUPLICATE_REQUEST });

    axios.post(`/menus/${menuId}/duplicate`, data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
